import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  padTop?: boolean;
  maxWidth?: number;
}

export function ScreenFrame({ children, padTop = true, maxWidth }: Props) {
  return (
    <div
      style={{
        flex: 1,
        overflow: 'auto',
        overflowX: 'hidden',
        padding: padTop ? '28px 32px 64px' : '0 32px 64px',
      }}
    >
      <div style={{ maxWidth: maxWidth ?? 1480, margin: '0 auto' }}>
        {children}
      </div>
    </div>
  );
}
